import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-70c90be1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bread-crumb"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon-add"
}, "+", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "breadcrumbLeft",
  style: {
    "margin-right": "20px"
  }
}, null, -1));
import { ArrowRight } from '@element-plus/icons-vue';
import useBread from './useBread';
import { useRoute } from 'vue-router';
import { ref, getCurrentInstance, h, render } from 'vue';
import { buttonList, showCreateAccount } from './button';
const __default__ = {
  name: 'BreadCrumb'
};
function setup(__props, {
  expose
}) {
  const route = useRoute();
  const breadcrumbs = ref();
  const {
    init
  } = useBread();
  init(getCurrentInstance());
  const buttonShow = item => showCreateAccount(item);
  setBread();
  // 自定义面包屑
  function setBread(val) {
    let sliceIdx = 0;
    if (route.meta.isSubMenu || route.meta.singleMenu) {
      sliceIdx = 1;
    }
    breadcrumbs.value = val || route.matched.slice(sliceIdx).filter(r => r.meta?.title);
  }
  // 左侧制定义
  const setLeftCom = v => {
    const dom = document.querySelector('#breadcrumbLeft');
    dom && render(v || h('div'), dom);
  };
  expose({
    setBread,
    setLeftCom
  });
  return (_ctx, _cache) => {
    const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
    const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
    const _component_el_button = _resolveComponent("el-button");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
      "separator-icon": _unref(ArrowRight)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, item => {
        return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: item.path,
          to: item
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.meta?.title), 1)]),
          _: 2
        }, 1032, ["to"]);
      }), 128))]),
      _: 1
    }, 8, ["separator-icon"]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(buttonList), items => {
      return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: items.id,
        type: "primary",
        class: "create-btn",
        onClick: $event => buttonShow(items)
      }, {
        default: _withCtx(() => [_hoisted_2, _createTextVNode(" " + _toDisplayString(items.title), 1)]),
        _: 2
      }, 1032, ["onClick"])), [[_vShow, _unref(route).path === items.path]]);
    }), 128)), _hoisted_3])]);
  };
}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup
});